import React from 'react'

const SvgDumbbellFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 16a3.998 3.998 0 003.465-2h5.077c.198.388 1.263 2 3.458 2 2.427 0 4-2 4-4 0-2.44-2.026-4-4-4-1.522 0-2.938.934-3.458 2.007 0 0-5.073-.007-5.073 0A4 4 0 106 16z'
    />
  </svg>
)

export default SvgDumbbellFilled
